import React from 'react';
import { useNavigate } from 'react-router-dom';
import { createProductUrl } from '../../utils/slugify';

const AmazonProductCard = ({ product }) => {
  const navigate = useNavigate();
  const {
    _id,
    sid,
    pid,
    price,
    mrp,
    title,
    imgurl,
    brand,
  } = product;

  const savings = mrp > price ? Math.round(((mrp - price) / mrp) * 100) : 0;

  const handleViewDeal = () => {
    const url = createProductUrl({ sid, pid, title });
    console.log('Navigating to product details:', url);
    navigate(url);
  };

  return (
    <div onClick={handleViewDeal} className="bg-white cursor-pointer rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:shadow-[0_15px_40px_rgba(126,84,242,0.12)] transition-all duration-500 overflow-hidden flex flex-col h-full border border-gray-100/50 group relative">
      {/* Amazon Logo Backdrop */}
      <div className="absolute top-4 right-4 z-10 opacity-100 group-hover:opacity-30 transition-opacity duration-500 pointer-events-none">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
          alt="Amazon"
          className="h-3.5 w-auto"
        />
      </div>

      {/* Premium Savings Badge */}
      {savings > 0 && (
        <div className="absolute top-3 left-3 z-20">
          <div className="relative group/badge">
            <div className="absolute inset-0 bg-[#7E54F2] blur-md opacity-40 group-hover/badge:opacity-60 transition-opacity"></div>
            <div className="relative bg-gradient-to-br from-[#7E54F2] to-[#6366F1] text-white text-[10px] font-black px-3 py-1.5 rounded-xl border border-white/20 shadow-xl flex items-center gap-1.5 uppercase tracking-wider transition-transform duration-300 hover:scale-105">
              <span className="flex h-1.5 w-1.5 rounded-full bg-white animate-pulse"></span>
              {savings}% OFF
            </div>
          </div>
        </div>
      )}

      {/* Image Container - Slightly shorter aspect ratio */}
      <div className="relative pt-[85%] bg-white group-hover:bg-gray-50/20 transition-colors duration-500">
        <img
          src={imgurl}
          alt={title}
          className="absolute top-0 left-0 w-full h-full object-contain p-2 sm:p-4 group-hover:scale-105 transition-transform duration-700 ease-out"
        />
      </div>

      <div className="p-3.5 flex flex-col flex-grow">
        <span className="text-[10px] font-black text-[#7E54F2] uppercase tracking-[0.25em] mb-1.5 opacity-60 block truncate">
          {brand || '\u00A0'}
        </span>
        <h3 className="text-slate-600 font-medium text-[12px] sm:text-[14px] leading-[1.4] mb-4 line-clamp-2 min-h-[2rem] group-hover:text-[#7E54F2] transition-colors duration-300">
          {title}
        </h3>

        <div className="mt-auto">
          <div className="flex items-center gap-2 mb-4 bg-gray-50/50 p-2.5 rounded-xl border border-gray-100">
            <div className="flex flex-col">
              <span className="text-[12px] text-gray-400 font-bold uppercase tracking-widest mb-0.5">Price</span>
              <span className="text-sm sm:text-base font-bold text-gray-900 tracking-tight">₹{price.toLocaleString()}</span>
            </div>
            {mrp > price && (
              <div className="flex flex-col ml-auto text-right">
                <span className="text-[12px] text-gray-400 font-bold uppercase tracking-widest mb-0.5">M.R.P</span>
                <span className="text-[14px] text-gray-300 font-medium line-through">₹{mrp.toLocaleString()}</span>
              </div>
            )}
          </div>

          <button
            className="w-full py-3 px-4 rounded-xl font-bold text-[10px] sm:text-xs text-white uppercase tracking-[0.15em] transition-all duration-300 bg-[#7E54F2] shadow-[0_5px_15px_rgba(126,84,242,0.15)] hover:shadow-[0_10px_25px_rgba(126,84,242,0.25)] hover:-translate-y-0.5 active:scale-95 flex items-center justify-center gap-2"
          >
            <span>View Deal</span>
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AmazonProductCard;
